<template>
  <el-aside width="200px">
    <el-menu
      class="menu__wrap el-menu-vertical-demo"
      router
      text-color="#777777"
      active-text-color="#FFFFFF"
      background-color="#191A1E"
      :default-active="$route.path"
      :collapse="isCollapse"
      :unique-opened="true"
    >
      <el-menu-item
        v-for="(item, index) in routes"
        :key="index"
        :index="item.path"
      >
        <div class="menu-item">
          <!-- <i class="el-icon-menu"></i> -->
          <div
            :class="
              item.path === isActive ? 'menu-item-box active' : 'menu-item-box'
            "
            @click="handleItem(item, index)"
          >
            <el-image
              class="menu-icon"
              style="width: 20px; height: 20px"
              :src="
                item.path === isActive ? item.meta.iconActive : item.meta.icon
              "
              fit="cover"
            ></el-image>
            <span slot="title"
              >{{ item.meta.title }}
              <el-badge
                v-show="unreadCount + read > 0"
                class="mark"
                :value="unreadCount + read"
                v-if="item.path == '/home'"
              />
              <el-badge
                class="mark"
                :value="pushNum"
                v-if="item.path == '/resumeManagement' && pushNum > 0"
              />
              <el-badge
                class="mark"
                :value="invite_unread"
                v-if="item.path == '/invites' && invite_unread > 0"
              />
            </span>
          </div>
        </div>
      </el-menu-item>
    </el-menu>
    <TUIConversation
      v-show="false"
      @getconversationList="getconversationList"
    ></TUIConversation>
  </el-aside>
</template>

<script>
import { remove } from "@/storage/index.js";
import { setStorage, getStorage } from "@/storage/index.js";
import { TUIConversation } from "../TUIKit";
export default {
  name: "LayoutNaviBar",
  props: ["isCollapse"],
  data() {
    return {
      isActive: getStorage("router_path"),
      role_type: getStorage("role_type"),
      routes: [],
      unreadCount: 0,
      read: 0,
      pushNum:0, 
      invite_unread: 0, //企业邀请未读数

    };
  },
  components: { TUIConversation },
  mounted() {
    // this.$router.push(this.isActive)
    this.isActive = this.$route.path;
    this.routes = this.$router.options.routes.slice(
      2,
      this.$router.options.routes.length - 1
    );
    if (this.role_type != 1) {
      this.routes = this.routes.filter(
        (item) => item.path !== "/accountManagement"
      );
    }
    this.getindex();
    this.getmsgCount();
    this.getWeIndex();
  },
  methods: {
    getWeIndex() {
      this.$http.get("/company/we/index", { params: {} }).then((res) => {
        if (res.code == 1) {
          this.invite_unread = res.data.invite_unread;
        }
      });
    },
    async getmsgCount() {
      try {
        const response = await this.$http.get("/company/resume/msgCount", { params: {} });
        if(response.code == 1) {
          this.pushNum = response.data.count;
        }
      } catch (error) {
        console.error(error);
      }
    },
    getresumeRead() {
      this.$http.post("/company/resume/read", { params: {} }).then(res =>{
      })
    },
    handleItem(item, index) {
      this.isActive = item.path;
      setStorage("router_path", item.path);
      this.$eventbus.$emit("layoutGetDetail");
    },
    getconversationList(list) {
      this.unreadCount = list.reduce((sum, item) => sum + item.unreadCount, 0);
    },
    getindex() {
      this.$http.get("/company/message/index", { params: {} }).then((res) => {
        this.read = res.data[1].count;
        this.$store.state.read = res.data[1].count;
      });
    },
  },
  beforeDestroy() {
    remove("router_path");
  },
  watch: {
    $route(to, from) {
      this.isActive = to.path;
      this.getindex();
      this.getmsgCount();
      this.getWeIndex()
      if(from.path == '/resumeManagement') {
        this.getresumeRead();
      }
    },
    "$store.state.isunread"(val) {
      this.getindex();
    },
  },
};
</script>
<style scoped lang="scss">
// .active {
//   background: #ffffff;
//   opacity: 0.1;
// }
.menu__wrap {
  height: 100%;
  box-sizing: border-box;
  // background: #191A1E;
  &::v-deep {
    // .el-menu-item i {
    //   color: #ffffff;
    // }
    // .el-menu-item {
    //   color: #ffffff;
    //   text-align: center;
    // }
    .el-menu-item.is-active {
      background-color: #0c64c6 !important;
    }
  }
  .menu-item {
    text-align: center;
  }
  .menu-icon {
    margin-right: 10px;
  }
  .menu-item-box {
    // display: flex;
    // align-items: center;
    // justify-content: end;
  }
  .menu-item-box:hover {
    // border-radius: 6px;
    // box-shadow: 1px 10px 15px 0px rgb(48 195 177 / 20%)
  }
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
::v-deep .menu-item .el-badge__content {
  border: none;
}
</style>
